import { FormattedMessage } from 'react-intl';
import { MultipleUsersSVG } from '../../../../../svgComponents/multipleUsersSVG/MultipleUsersSVG';
import { PaymentCardSVG } from '../../../../../svgComponents/paymentCardSVG/PaymentCardSVG';
import { RocketSVG } from '../../../../../svgComponents/rocketSVG/RocketSVG';
import IwMedia from '../../../../../iwMedia/IwMedia';
import styles from './ApprovalSubHeader.module.css';
import messages from './ApprovalSubHeader.messages';

const ApprovalSubHeader = () => (
    <IwMedia from="medium">
        <div className={styles.subHeader} data-testid="loan-builder-subheader">
            <ul className={styles.row}>
                <li className={styles.lineItem}>
                    <MultipleUsersSVG className={styles.multipleUsersSVG} />
                    <FormattedMessage {...messages.subheaderOne} />
                </li>
                <li className={styles.lineItem}>
                    <RocketSVG className={styles.rocketSVG} />
                    <FormattedMessage {...messages.subheaderTwo} />
                </li>
                <li className={styles.lineItem}>
                    <PaymentCardSVG className={styles.paymentSVG} />
                    <FormattedMessage {...messages.subheaderThree} />
                </li>
            </ul>
        </div>
    </IwMedia>
);

// eslint-disable-next-line import/no-default-export
export default ApprovalSubHeader;
